<template>
  <router-link to="/add-your-face" class="add-face">
    <span
      class="add-cont"
      data-mouse
      data-mouse-attractionState="active"
      data-mouse-attractionVal="20"
      data-mouse-magnetism="5"
      data-hover-type="fadeout"
      ref="plus"
    >
      <span class="svg-cont">
        <svg viewBox="-2 -2 86 86" xmlns="http://www.w3.org/2000/svg">
          <g fill-rule="nonzero" fill="none">
            <path class="svg__circle" d="M41 81c22.091 0 40-17.909 40-40S63.091 1 41 1 1 18.909 1 41s17.909 40 40 40z" stroke="#fff"/>
            <path class="svg__plus" d="M17 41h49v2H17z" stroke="#fff"/>
            <path class="svg__plus" d="M41 17h2v49h-2z" stroke="#fff"/>
          </g>
        </svg>
      </span>
      <span class="add__caption" data-text>Add your face</span>
    </span>
  </router-link>
</template>

<script>
import gsap from 'gsap';

const SplitText = require('../assets/lib/gsap/uncompressed/utils/SplitText'); // eslint-disable-line


export default {
  name: 'AddFace',

  props: ['loaderIsOut'],

  watch: {
    loaderIsOut(newVal) {
      if (newVal) this.enterHeader();
    },
  },

  methods: {
    enterHeader() {
      const text = this.$el.querySelector('[data-text]');
      const split = new SplitText(text, { type: 'chars' });
      const tl = new gsap.TimelineMax({
        delay: 0.6,
        onComplete: () => {
          split.revert();
        },
      });

      tl.add('start')
        .staggerFrom(split.chars, 0.8, {
          yPercent: 20,
          autoAlpha: 0,
          ease: gsap.Power2.easeInOut,
        }, 0.01, 'start')
        .from(this.$refs.plus, 1, {
          autoAlpha: 0,
        }, 'start');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/colors';
@import '../application';

.add-face {
  display: inline-block;
  position: absolute;
  opacity: 0;
  width: 0;
  overflow: hidden;

  @include mq(sm) {
    position: relative;
    opacity: 1;
    width: auto;
    overflow: visible;
  }

  .add-cont {
    position: relative;
    display: inline-block;
  }

  .svg-cont {
    position: relative;
    display: inline-block;
    padding: 5px;

    @include mq(sm) {
      padding: 20px;
    }

    .svg__plus,
    .svg__circle,
    .add__caption {
      transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
    }
  }

  .add__caption {
    font-size: .875rem;
    padding-right: 20px;
  }

  .add__caption {
    transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);
  }

  svg {
    display: inline-block;
    width: 30px;
    transform-origin: 100% 0;
    transform: scale(0.8);
  }

  .svg__plus {
    stroke-width: 2;
    transform-origin: 50% 50%;
    transform: scale(0.8);
  }

  .svg__circle {
    stroke-width: 5;
  }

  &:hover .svg__plus {
    stroke: $color-blue;
    stroke-width: 3;
  }

  &:hover .svg__circle {
    stroke: $color-blue;
    stroke-width: 5;
  }

  &:hover .add__caption {
    color: $color-blue;
  }

  &.router-link-active {
    .svg__plus {
      stroke: $color-blue;
      stroke-width: 3;
    }

    .svg__circle {
      stroke: $color-blue;
      stroke-width: 5;
    }

    .add__caption {
      color: $color-blue;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/FooterAddFace.vue